module.exports = __webpack_public_path__ + "media/educator_advisory_board/Sandra_Carter-57a08c93.png";